module.exports = __webpack_public_path__ + "img/slider-9.1cb7355d.jpg";